export { default as memoize } from "./memoize";
export { default as getThemeObject } from "./getThemeObject";
export { default as getThemeValue } from "./getThemeValue";
export { default as composeEventHandlers } from "./composeEventHandlers";
export { getRelByTarget, getAsProp } from "./link";
export { default as omitKeys } from "./omitKeys";
export { default as sluggify } from "./text";
export { getFontColor, getFontHue, getLabelTextColor } from "./typography";
export { default as throttle } from "./throttle";
export {
  default as isValidThemeColorVariant
} from "./isValidThemeColorVariant";
export { default as getBackgroundImage } from "./getBackgroundImage";



// WEBPACK FOOTER //
// ./src/utils/index.js